// extracted by mini-css-extract-plugin
module.exports = {"chipsContainer":"_17eEf","searchContainer":"UcUg0","iconContainer":"h6D7R","searchValue":"hc0Ky","chipsOutside":"y8ssj","chips":"_0HbDI","chip":"LN1Ou","chipSelected":"zTg81"};